var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-rect',{attrs:{"config":_vm.item}})}
var staticRenderFns = []

export { render, staticRenderFns }